import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';
import styled from 'styled-components';

import { defaultThemeProp } from '../../theme';
import type { NoChildrenProp, RefElement, WithAttributes } from '../../types';
import Button from '../Button';
import { ThemeOverride } from '../Configuration';
import { useTheme } from '../../hooks';

export type DangerButtonProps = WithAttributes<
  'button',
  NoChildrenProp & {
    /** Text content for the button. */
    label: NonNullable<HTMLButtonElement['textContent']>;
    /**
     * Elevates emphasis for button style.
     * @default false
     */
    primary?: boolean;
  }
>;

export const StyledDangerButton = styled(Button)``;

StyledDangerButton.defaultProps = defaultThemeProp;

export default forwardRef<RefElement<DangerButtonProps>, PropsWithoutRef<DangerButtonProps>>(
  function DangerButton({ label, primary = false, ...restProps }, ref) {
    const theme = useTheme();

    return (
      <ThemeOverride
        theme={{
          base: {
            palette: {
              interactive: theme.base.palette.urgent
            }
          }
        }}
      >
        <StyledDangerButton {...restProps} variant={primary ? 'primary' : undefined} ref={ref}>
          {label}
        </StyledDangerButton>
      </ThemeOverride>
    );
  }
);
